module.exports = __webpack_public_path__ + "fe4d22ce233d1de3dbc11d40053a133c.svg";